export const PAGE_STATE: any[] = [
  {
    currentUrl: '/payment',
    nextUrl: '/planOwner',
    backUrl: '',
    name: 'Payment Information',
    backName: 'Your Payment Plan',
    retirementBackName: 'Retirement Advice Summary'
  },
  {
    currentUrl: '/planOwner',
    nextUrl: '/peopleOnYourPlan',
    backUrl: '/payment',
    name: 'Personal Information',
    backName: 'Payment Information'
  },
  {
    currentUrl: '/peopleOnYourPlan',
    nextUrl: '/declaration',
    backUrl: '/planOwner',
    name: 'Beneficiary Information',
    backName: 'Personal Information'
  },
  {
    currentUrl: '/declaration',
    nextUrl: '/adviser',
    backUrl: '/peopleOnYourPlan',
    name: 'Declaration Information',
    backName: 'Beneficiary Information'
  },
  {
    currentUrl: '/adviser',
    nextUrl: '/finalize',
    backUrl: '/declaration',
    name: 'Advisor Information',
    backName: 'Declaration Information'
  },
  {
    currentUrl: '/finalize',
    nextUrl: '',
    backUrl: '/adviser',
    name: 'Finalise Information',
    backName: 'Advisor Information'
  }
];
export const APP_ACTIONS = {
  'NEXT': 1,
  'PREV': -1
};